import { Route, Routes } from 'react-router-dom'
import IndicatorListPage from './Page'

export default function IndicatorList({ adminStandards}) {
  return (
    <Routes>
        <Route path="/" element={<IndicatorListPage adminStandards={adminStandards}/>} />
    </Routes>
  )
}